import { useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MeContext } from '../../../../context/MeContext';

export const CREATE_TEMPLATE_PATH = '/pass-templates/create';
export const TEMPLATES_LIST_PATH = '/pass-templates';

const PICKER_PARAM = 'createTemplate';

export const useCreateTemplateAction = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const meCtx = useContext(MeContext) as {
    state?: { prebuiltTemplatesEnabled?: boolean };
  };
  const prebuiltEnabled = Boolean(meCtx?.state?.prebuiltTemplatesEnabled);

  const isPickerOpen = searchParams.get(PICKER_PARAM) === '1';

  const setPickerParam = (open: boolean) => {
    const next = new URLSearchParams(searchParams);
    if (open) next.set(PICKER_PARAM, '1');
    else next.delete(PICKER_PARAM);
    setSearchParams(next, { replace: true });
  };

  const openPicker = () => setPickerParam(true);
  const closePicker = () => setPickerParam(false);

  const startFromBlank = () => navigate(CREATE_TEMPLATE_PATH);
  const startFromPreset = (presetId: string) =>
    navigate(CREATE_TEMPLATE_PATH, { state: { presetId } });

  const createTemplateTo = prebuiltEnabled
    ? `${TEMPLATES_LIST_PATH}?${PICKER_PARAM}=1`
    : CREATE_TEMPLATE_PATH;

  return {
    prebuiltEnabled,
    isPickerOpen,
    openPicker,
    closePicker,
    startFromBlank,
    startFromPreset,
    createTemplateTo,
  };
};
